import React from "react";
import { isEmpty } from "lodash";
import { ConsultantUpcomingWorkplace } from "@bonliva-crm/graphql";
import { ListItem, List, ListItemSecondaryAction, ListItemText } from "@material-ui/core";
import { useGlobalStore } from "@hooks";
import locale from "@bonliva-crm/locale";
import { BookingProfileLocation } from "@navigation/locations";
import { OutwardArrowIcon } from "../../../icons";
import { Color } from "../../../theme";
import { useSnackbarsPipeline } from "../../../feedback";

type Props = {
  items: ConsultantUpcomingWorkplace[];
  onClick?: () => void;
};

export function WorkplaceTitle({ items, onClick }: Props) {
  const store = useGlobalStore();
  const { showError } = useSnackbarsPipeline();

  if (isEmpty(items)) {
    return null;
  }

  const handleClick = (bookingId: string) => {
    if (bookingId) {
      if (onClick) onClick();
      store.navigation.open("bookingSlide", new BookingProfileLocation(bookingId));
    } else {
      showError(locale.missing);
    }
  };

  return (
    <List
      dense
      style={{
        backgroundColor: Color.Body,
        color: Color.White,
        borderRadius: "10px"
      }}
    >
      {items.map((w, index) => (
        <ListItem key={index} dense onClick={() => handleClick(w.bookingId)}>
          <ListItemText
            secondaryTypographyProps={{ color: "initial" }}
            id={`${index}${w.workplace?.Id}`}
            primary={w.workplace?.Name ?? locale.missing}
            secondary={w.department.map((x) => x.Name).join(", ")}
          />

          <ListItemSecondaryAction>
            <OutwardArrowIcon htmlColor={Color.White} style={{ marginTop: "7px" }} />
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
}
